/* eslint-disable max-len */
import { SvgIcon } from '@mui/material';
import { FC } from 'react';

const MRO: FC = () => (
  <SvgIcon fontSize="inherit">
    <svg fill="none" version="1.1" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
      <g transform="matrix(.71045 0 0 .71045 -535.32 -1576.4)" fill="currentColor">
        <path d="m787.08 2239.1c-0.31 0.55-1.61 1.58-3.52 2.47l-13.8 5.58c-1.16 0.47-11.52 2.47-11.52 2.47s-4.41-5.64-4.49-5.73l1.5-0.84c1.39 0.49 3.86 1.51 6.63 2.46 1.59-0.68 3.28-1.5 5.05-2.22l-9.42-9.05 2.15-0.73s3.43 1.16 7.67 3.14c4.41 2.06 7.05 3.61 7.22 3.45 0.28-0.07 5.45-2.03 6.49-2.36 1.97-0.63 3.96-0.23 5.75 0.6z" />
        <path d="m755.73 2228.7c-0.5-0.5-0.5-1.31 0-1.8 0.5-0.5 1.31-0.5 1.8 0s0.5 1.31 0 1.8c-0.49 0.5-1.3 0.5-1.8 0m30.88 1.68s-3.2 0.01-3.52 0.02c-0.33 0-0.86-0.56-0.86-0.56s-1.29-1.62-1.29-2.03c0-0.42 1.37-2.08 1.37-2.08s0.38-0.46 0.8-0.47h3.53s0.42-0.02 0.14-0.31c-0.93-0.93-2.85-2.8-4.68-2.8h-0.38c-2.18 0.01-3.89 1.58-4.19 3.63l-21.19-0.52c-0.85 0-2.58 0.6-2.57 2.58 0 1.98 1.73 2.57 2.58 2.57l21.19-0.5c0.3 2.05 2.01 3.62 4.19 3.62h0.38c1.78 0 3.68-1.86 4.63-2.8 0.29-0.32-0.13-0.35-0.13-0.35" />
      </g>
    </svg>
  </SvgIcon>
);

export default MRO;
